<template>
  <section ref="pageRef" class="py-16 px-4 max-w-3xl mx-auto text-gray-800">
<div class="text-center mb-12">
  <!-- Linie oben -->
  <div class="w-40 h-[3px] mx-auto mb-3 rounded-full bg-gradient-to-r from-blue-100 via-green-100 to-blue-200"></div>

  <!-- Überschrift -->
  <h2 class="text-2xl font-semibold text-gray-800">
    Supervision
  </h2>

  <!-- Linie unten -->
  <div class="w-40 h-[3px] mx-auto mt-3 rounded-full bg-gradient-to-l from-blue-100 via-green-100 to-blue-200"></div>
</div>

    <div>
      <p class="mb-4 text-center">
        <strong>Clinical Supervision for Counselling Professionals</strong><br />
        Offered by a qualified Counselling Psychologist, HCPC registered
      </p>

      <p class="mb-6">
        I provide clinical supervision for counsellors, psychotherapists, psychologists, and trainees.
        My approach is collaborative, reflective, and grounded in integrative and relational models.
        I aim to offer a supportive, ethical, and growth-oriented space.
      </p>
    </div>

    <div class="bg-gray-50 border rounded p-6 space-y-4 shadow-sm">
      <div>
        <h3 class="font-semibold text-lg mb-2">What I Offer</h3>
        <ul class="list-disc list-inside space-y-1">
          <li>Individual supervision (online)</li>
          <li>Support for trainees & early career therapists</li>
          <li>Integrative and relational approach</li>
          <li>Safe, reflective, and professional space</li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold text-lg mb-2">Areas of Interest</h3>
        <ul class="list-disc list-inside space-y-1">
          <li>Relational depth in therapy</li>
          <li>Working with trauma and complex presentations</li>
          <li>Intersectionality and identity</li>
          <li>Therapist self-care and boundaries</li>
          <li>Clinical reflection and formulation</li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold text-lg mb-2">Location & Fees</h3>
        <p>Supervision is available online.</p>
        <p>Fees: <strong>£60</strong> per 50-minute session (reduced rates available for trainees).</p>
      </div>
    </div>

    <div class="mt-6 text-center">
      <p>If you’re interested in working together or would like to arrange an initial chat:</p>
      <router-link
          to="/contact"
          class="inline-block mt-4 bg-gray-800 text-white px-6 py-2 rounded hover:bg-gray-700 transition"
      >
        Contact Me
      </router-link>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const pageRef = ref(null)

onMounted(() => {
  gsap.from(pageRef.value, {
    opacity: 0,
    scale: 0.95,
    duration: 1.2,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: pageRef.value,
      start: 'top 95%',
    }
  })
})
</script>
